<template>
  <LcForm :tracking="{ containerId: CONTAINER_ID }">
    <LcFormField v-slot="{ field }" name="method">
      <LcRadioGroup v-bind="field" v-model:value="model" layout="vertical">
        <template v-for="account in accounts" :key="account.id">
          <component :is="IMPLEMENTATIONS[account.type]" v-bind="getProps(account)" />
        </template>
      </LcRadioGroup>
    </LcFormField>
  </LcForm>
</template>

<script lang="ts" setup>
import { PayOutAccountType } from '#api/shared/@types/generated/backend/graphql-schema-types'
import {
  PayoutStoredMethodAeropay,
  PayoutStoredMethodBank,
  PayoutStoredMethodPayPal,
} from '#components'

import { getProps, type PayoutStoredAccounts } from './PayoutStoredComponentMapper'

type PayoutStoredMethodSelectorProps = { accounts: PayoutStoredAccounts }

const CONTAINER_ID = 'payout_method_stored_form'

const IMPLEMENTATIONS = {
  [PayOutAccountType.Aeropay]: PayoutStoredMethodAeropay,
  [PayOutAccountType.Bank]: PayoutStoredMethodBank,
  [PayOutAccountType.PayPal]: PayoutStoredMethodPayPal,
} as const

defineProps<PayoutStoredMethodSelectorProps>()

const model = defineModel<string | undefined>('selectedMethod', {
  default: undefined,
  type: String,
})
</script>
